import { selectActiveFirm } from "@/store/appSelectors";
import { useSelector } from "react-redux";
import { addContentGroupTag, deleteContentGroupTag } from "@/sideEffects/api";
import { EntityTagsUpdatePopover } from "@/components/tags/EntityTagsUpdatePopover";
import { ContentGroupTag } from "@/lib/types";

interface Props {
  contentGroupIntId: number;
  contentGroupTags: ContentGroupTag[];
  onUpdate: () => void;
}

export const ContentGroupTagsUpdatePopover: React.FC<Props> = ({ contentGroupIntId, contentGroupTags, onUpdate }) => {
  const activeFirm = useSelector(selectActiveFirm);

  return (
    <EntityTagsUpdatePopover
      addFn={(tagIntId) =>
        addContentGroupTag({
          firmGuid: String(activeFirm?.firmGuid),
          contentGroupIntId: contentGroupIntId,
          tagIntId: tagIntId,
        })
      }
      deleteFn={(contentGroupTagId) =>
        deleteContentGroupTag({ firmGuid: String(activeFirm?.firmGuid), contentGroupTagId: contentGroupTagId })
      }
      entityAssignedTagIntIds={contentGroupTags.map((tag) => ({ tagIntId: tag.tagintId, id: tag.id }))}
      onUpdate={onUpdate}
    />
  );
};
